/**
 * @desc 入库单已上架通知履约入库
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.test.inFinishNotifyFulfilmentInbound.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/test/inFinishNotifyFulfilmentInbound`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
